
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/facebook/callback",
      function () {
        return require("private-next-pages/auth/facebook/callback.tsx");
      }
    ]);
  